import React from "react";
import "../styles/Footer.css";

import { useScrollTo } from "react-use-window-scroll";
import {
  SiAcclaim,
  SiGithub,
  SiTwitter,
  SiWhatsapp,
  SiLinkedin,
  SiGmail,
} from "react-icons/si";

function Footer() {
  const scrollTo = useScrollTo();
  const currentYear = new Date().getFullYear();

  return (
    <div className="footer" id="footer">
      <div>
        <button
          onClick={() => scrollTo({ top: 0, left: 0, behavior: "smooth" })}
        >
          {" "}
          <span>
            <SiAcclaim />
          </span>{" "}
          <br />
          Back to Top
        </button>
      </div>

      <div className="social">
        <a
          href="https://github.com/diydiyydiyyy"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          <SiGithub />
        </a>

        <a href="https://twitter.com/readiygo" target="_blank" rel="noreferrer">
          {" "}
          <SiTwitter />
        </a>

        <a
          href="mailto:chalimatus.sadiyah.098@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          <SiGmail />
        </a>

        <a href="https://wa.me/085601648494" target="_blank" rel="noreferrer">
          {" "}
          <SiWhatsapp />
        </a>

        <a
          href="https://www.linkedin.com/in/chalimatussadiyah/"
          target="_blank"
          rel="noreferrer"
        >
          {" "}
          <SiLinkedin />
        </a>
      </div>

      <div>
        <p>
          &copy; {currentYear} <b>Chalimatus Sa’diyah</b> All Rights Reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
